export const cssSafeName = (input: string): string =>
  input.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~ ]/g, '');
